import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Step1Email from './components/Step1_Email';
import AuthPage from './components/AuthPage';
import Step3PlanSelection from './components/Step3_PlanSelection';
import Step4Payment from './components/Step4_Payment';
import Step5Success from './components/Step5_Success';
import CancelPage from './components/CancelPage';        //  NEW IMPORT
import InvoiceGenerator from './components/InvoiceGenerator';

function App() {
  const [userData, setUserData] = useState({
    email: '',
    fullName: '',
    selectedPlan: null
  });

  return (
    <BrowserRouter>
      <Routes>
        {/* Step 1: Email input */}
        <Route path="/" element={<Step1Email userData={userData} setUserData={setUserData} />} />
        
        {/* Step 2: Signup/Login */}
        <Route path="/auth" element={<AuthPage userData={userData} setUserData={setUserData} />} />
        
        {/* Step 3: Choose subscription plan */}
        <Route path="/subscribe" element={<Step3PlanSelection userData={userData} setUserData={setUserData} />} />
        
        {/* Step 4: Payment */}
        <Route path="/payment" element={<Step4Payment userData={userData} />} />
        
        {/*  NEW ROUTES */}
        <Route path="/success" element={<Step5Success />} />
        <Route path="/cancel" element={<CancelPage />} />     {/*  FIXED */}
        <Route path="/invoice/:subscriptionId" element={<InvoiceGenerator />} />
        
        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
      <ToastContainer 
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </BrowserRouter>
  );
}

export default App;
